import create from "zustand";
import { produce } from "immer";

import { getS3FileKey, isEmpty } from "../utils/index.js";

let fetchAccountDetails = async function fetchingAccountDetails() {
  if (window.accountDetails.hasOwnProperty("error_code")) {
    return Promise.reject(new Error(window.accountDetails));
  } else if (window.accountDetails?._id) {
    let accountDetails = window.accountDetails;
    if (accountDetails?.IsPortal) {
      let { OAuth2, ...portalData } = accountDetails.PortalData;
      Reflect.deleteProperty(portalData, "_id");
      accountDetails = {
        ...accountDetails,
        ...portalData,
        portalOAuth2: OAuth2
      };
    }
    const { CompanyLogo, AttachmentPreference, AppConfig } = accountDetails;
    if (CompanyLogo) {
      accountDetails.CompanyLogo.url =
        `${AppConfig.ProfileBasePath}/` +
        `${getS3FileKey(CompanyLogo.Rectangle.key)}`;
    }
    // Fallback for attachmentPreference
    if (!AttachmentPreference || isEmpty(AttachmentPreference)) {
      accountDetails.AttachmentPreference = {
        LocalFiles: true
      };
    }
    if (accountDetails.UserDetails?.AccountDetails?.Geolocation) {
      accountDetails.AppConfig.Geolocation =
        accountDetails.UserDetails.AccountDetails.Geolocation;
    }
    accountDetails.Language =
      accountDetails.UserDetails?.Language || accountDetails.Language;

    accountDetails.MailConfig =
      accountDetails.UserDetails?.AccountDetails?.MailConfig;
    return Promise.resolve(accountDetails);
  } else {
    return Promise.reject(new Error("Invalid account"));
  }
};

export const useAccountStore = create((set, get) => {
  async function load() {
    let accountDetails = await fetchAccountDetails();
    set(accountDetails);
    window.accountDetails = accountDetails;
    return accountDetails;
  }

  async function getAccountDetails() {
    if (get()._id) {
      return get();
    } else {
      let accountDetails = await fetchAccountDetails();
      set(accountDetails);
      window.accountDetails = accountDetails;
      return accountDetails;
    }
  }

  function setTranslationLoader(translationLoader) {
    set({
      translationLoader
    });
  }

  function setShowThemePreviewBanner(isOn = false) {
    set({
      showThemePreviewBanner: isOn
    });
  }

  function setLanguage(languageData) {
    set({
      Language: languageData
    });

    console.info("=== language is set inside store ====", get().Language);
  }

  function update(stateFn) {
    set(produce(stateFn));
  }

  function updateGeolocationKey(value) {
    set(
      produce((state) => {
        state.AppConfig.Geolocation = value;
      })
    );
  }

  return {
    translationLoader: null,
    load,
    getAccountDetails,
    setLanguage,
    setTranslationLoader,
    update,
    setShowThemePreviewBanner,
    updateGeolocationKey
  };
});
